<template>
  <div class="diary-dates">
    <div class="dialog">
      <router-link
        class="close-button"
        :title="$t('Cancel')"
        :to="{ name: 'ProjectOverview', params: { _id: $route.params._id } }"
      >
        <b-icon icon="x" class="d-block" />
      </router-link>
      <h1>{{ $t('Missing diary!') }}</h1>
      <br />
      <h2>{{ $t('The project diary is not complete, Click on the date below to fill out') }}</h2>
      <br />
      <div class="date-list">
        <div class="date" v-for="dat in currentProjectMissingDiaryEntries" :key="dat">
          <router-link :title="dat" :to="{ name: 'DiaryEdit', params: { _id: $route.params._id, date: dat } }">
            {{ dayname(dat) }} {{ dat }}
          </router-link>
          <span>({{ daysAgo(dat) }})</span>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
/** @todo This component seems to be unused. */
import { mapGetters, mapActions } from 'vuex';
import CommonHeader from '@/components/toolbar/CommonHeader';
import CommonFooter from '@/components/toolbar/CommonFooter';
import moment from 'moment';
import DatePicker from '@/components/datepicker/DatePicker';

import DiaryEdit from '@/components/diary/DiaryEdit';

export default {
  name: 'Diary',
  metaInfo() {
    return {
      title: this.$t('Diary'),
    };
  },
  created: function () {
    this.loadProject(this.$route.params._id);
    if (this.currentProjectMissingDiaryEntries.length <= 1) {
      let today = moment().format('YYYY-MM-DD');
      this.$router.push({ name: 'DiaryEdit', params: { _id: this.$route.params._id, date: today } });
    }
  },
  computed: {
    ...mapGetters(['currentProject', 'currentProjectMissingDiaryEntries']),
  },
  methods: {
    ...mapActions(['loadProject']),
    dayname(day) {
      return this.$t(moment(day).format('dddd'));
    },
    daysAgo(dat) {
      let days = moment().diff(dat, 'days');
      if (days === 0) {
        return this.$t('Today');
      }
      return this.$t('Yesterday ::: {days} days ago', { days }, days);
    },
  },
  watch: {
    $route(to, from) {
      console.debug('ProjectOverview:watch');
      this.loadProject(this.$route.params._id);
    },
  },
  components: {
    CommonFooter,
    CommonHeader,
    DiaryEdit,
    DatePicker,
  },
};
</script>
<style scoped>
.diary-dates {
  width: 100%;
  color: black;
  font-family: Montserrat;
  padding: 0px;
}

.diary-dates h2 {
  font-weight: 200;
  font-size: 17px;
  color: #494d5a;
}

.date-list {
  width: 100%;
  overflow-y: auto;
}

.date-list a {
  display: block;
}

.date-list .date {
  font-weight: bold;
  font-size: 18px;
  margin-top: 3mm;
  display: block;
  color: #494d5a;
}

.date-list .date:first-child {
  font-size: 24px;
}

.date-list span {
  font-size: 16px;
}

.diary-dates h1 {
  font-style: italic;
  font-weight: 700;
  font-size: 28px;
}

.dialog {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 8cm;
  margin-left: auto;
  margin-right: auto;
  padding: 1cm 0mm 0mm 0mm;
  background: white;
  border-radius: 7mm;
  position: relative;
  min-height: 50vh;
  max-height: 80vh;
  align-content: flex-start;
  justify-content: flex-start;
}

.close-button {
  font-size: 40px;
  position: absolute;
  right: 6px;
  top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiaryListDates.vue